import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import withPermissions from '../../../../../../auth/utils/withPermissions';

import {
  activeShopCommissionSplits,
  activeShop,
  getActiveType,
  getBarberUser,
} from '../../../../../../auth/selectors';
import { canViewCommissionPayoutReport } from '../../../../../../common/helpers/reports';
import { canUseCommissionReporting } from '../../../../../../common/helpers/users';
import withBoundingClientRect from '../../../../../../common/hoc/withBoundingClientRect';

const COMPACT_LAYOUT_SIZE_PX = 1100;

const HeaderContainer = items => compose(
  withPermissions,
  withRouter,
  withBoundingClientRect,
  connect((state, ownProps) => ({
    items,
    pathname: ownProps.router.location.pathname,
    user: state.auth.user,
    shop: activeShop(state),
    canUseCommissionReporting: canUseCommissionReporting(state),
    commissionSplits: activeShopCommissionSplits(state),
    activeType: getActiveType(state),
    barber: getBarberUser(state),
    canViewCommissionReport: canViewCommissionPayoutReport(state),
  })),
  withProps(props => ({
    compact: !props.boundingClientRect.width || (props.boundingClientRect.width < COMPACT_LAYOUT_SIZE_PX),
  })),
);

export default HeaderContainer;
